(() => {
  var BDTabContainerApp = (() => {
    var open = (container, data_symbol, data_index) => {
      if (!container || data_index === '') return;
      container.querySelectorAll('[js-tab-header], [js-tab-body]').forEach(element => {
        if (element.getAttribute('data-symbol') == data_symbol) {
          element.classList.remove('active');
          if (element.getAttribute('data-index') === data_index) {
            element.classList.add('active');
          }
        }
      });
    }
    var initialize = () => {
      document.querySelectorAll('[js-tab-container] [js-tab-header]').forEach(element => {
        element.addEventListener('click', () => {
          open(element.closest('[js-tab-container]'), element.getAttribute('data-symbol'), element.getAttribute('data-index'));
        });
      });
    }
    return {
      init: initialize
    }
  })();
  
	
  var FAQApp = (() => {
    var close = (block) => {
      if (!block) return;
      block.classList.remove('open');
    }
    var open = (block) => {
      if (!block) return;
      const container = block.closest('[js-faq]');
      if (container) {
        container.querySelectorAll('[js-faq-block]').forEach(element => {
          close(element);
        });
      }
      block.classList.add('open');
    }
    var initialize = () => {
      document.querySelectorAll('[js-faq] [js-faq-block] [js-question]').forEach(element => {
        element.addEventListener('click', () => {
          if (element.closest('[js-faq-block]').classList.contains('open')) {
            close(element.closest('[js-faq-block]'));
          } else {
            open(element.closest('[js-faq-block]'));
          }
        });
      });
    }
    return {
      init: initialize
    }
  })();

  let variantPickerApp = (() => {
    let initialize = () => {
      const variantElements = document.querySelectorAll('.thumbnail-swatch');
      variantElements.forEach((ele) => {
        ele.addEventListener("click", () => {
          const inputID = ele.getAttribute("for");
          let colorValue = '';
          if (inputID) {
            colorValue = document.getElementById(inputID).value;
            console.log("This is the color value", colorValue);
          }
          document.querySelectorAll(".pi-image-gallery-carousel .variant-color-image").forEach((image) => {
            if (image.dataset.colorValue == colorValue) {
              image.classList.add("active");
            } else {
              image.classList.remove("active");
            }
          });
          document.querySelectorAll(".pi-image-gallery-carousel-nav .variant-color-image").forEach((image) => {
            if (image.dataset.colorValue == colorValue) {
              image.classList.add("active");
            } else {
              image.classList.remove("active");
            }
          });

          variantElements.forEach((element) => {
            element.classList.remove("active");
          });
          ele.classList.add("active");
        });
      });
    }
    return {
      init: initialize
    }
  })();

  var pdpAsLandingSliderApp = (() => {
    var initialize = () => {
      const mainSlider = new Flickity('#pi-image-gallery-main', {
				initialIndex: 1,
        draggable: true,
        prevNextButtons: false,
        adaptiveHeight: false,
        wrapAround: false,
        pageDots: false,
        contain: false,
        imagesLoaded: true,
        cellAlign: 'left',
        percentPosition: false
      });
      const navSlider = new Flickity('#pi-image-gallery-nav', {
				initialIndex: 1,
        draggable: true,
        prevNextButtons: false,
        adaptiveHeight: false,
        wrapAround: false,
        pageDots: false,
        contain: false,
        imagesLoaded: true,
        asNavFor: '#pi-image-gallery-main',
        cellAlign: 'left',
        percentPosition: false
      });

      // Sync thumbnail highlight
      mainSlider.on('select', () => {
        document.querySelectorAll('.image_wrapper--thumb').forEach((thumb, i) => {
          thumb.classList.toggle('is-selected', i === mainSlider.selectedIndex);
        });
      });

      // On variant/color change — swap only slot 1 & 2
      function updateVariantImages(variantId) {
        console.log('1. variantId received:', variantId);
        console.log('2. window.variantImages:', window.variantImages);
        const data = window.variantImages[variantId];
        if (!data) return;
        console.log('4. image1 url:', data.image1);  

        // Update main slider slides
        [1].forEach(slot => {
          const slides = document.querySelectorAll(
            `.pi-image-gallery-variant[data-slot="${slot}"]`
          );
          console.log(`6. slides found for slot ${slot}:`, slides.length);

          slides.forEach(slide => {
            let img = slide.querySelector('img');
            if (!img) {
              console.log(`7. slides found for slot ${slot}:`, slides.length);
              img = document.createElement('img');
              slide.appendChild(img);
            }
            const imgSrc = slot === 1 ? data.image1 : data.image2;
            
            setTimeout(() => {
              img.removeAttribute('nsfwimgid');
              img.removeAttribute('nsfwstatus');
              img.removeAttribute('nsfworiginalSrc');
              img.removeAttribute('srcset');
              img.removeAttribute('data-src');
              img.removeAttribute('data-srcset');

              img.src = imgSrc;

              img.onload = () => {
                mainSlider.reloadCells();
                navSlider.reloadCells();
                mainSlider.resize();
                navSlider.resize();
                mainSlider.select(0, false, true);
              };
            }, 100);
          });
        });

        // Update thumbnails
        [1].forEach(slot => {
          const thumb = document.querySelector(
            `.pi-image-gallery-thumb-variant[data-slot="${slot}"]`
          );
          if (thumb) {
            // const img = thumb.querySelector('img') || document.createElement('img');
            // img.src = slot === 1 ? data.thumb1 : data.thumb2;
            // if (!thumb.querySelector('img')) thumb.appendChild(img);
            
            let img = thumb.querySelector('img');
            if (!img) {
              img = document.createElement('img');
              thumb.appendChild(img);
            }
            const imgSrc = slot === 1 ? data.thumb1 : data.thumb2;
            
            setTimeout(() => {
              img.removeAttribute('nsfwimgid');
              img.removeAttribute('nsfwstatus');
              img.removeAttribute('nsfworiginalSrc');
              img.removeAttribute('srcset');
              img.removeAttribute('data-src');
              img.removeAttribute('data-srcset');

              img.src = imgSrc;

              img.onload = () => {
                mainSlider.reloadCells();
                navSlider.reloadCells();
                mainSlider.resize();
                navSlider.resize();
                mainSlider.select(0, false, true);
              };
            }, 100);
          }
        });

        // Resize Flickity after image swap
        // setTimeout(() => {
        //   mainSlider.reloadCells();
        //   navSlider.reloadCells();
        //   mainSlider.select(0, false, true);
        // }, 150);
        // mainSlider.reloadCells();
        // navSlider.reloadCells();
        mainSlider.resize();
        navSlider.resize();

        // Jump back to slide 1
        // mainSlider.select(0, false, true);
      }

      // Hook into variant change — adjust selector to match your swatch markup
      document.querySelectorAll('[data-variant-id]').forEach(swatch => {
        swatch.addEventListener('click', () => {
          updateVariantImages(swatch.dataset.variantId);
        });
      });

      // Also listen to Shopify's native variant change event
      document.addEventListener('variant:changed', (e) => {
        if (e.detail?.variant?.id) {
          updateVariantImages(e.detail.variant.id);
        }
      });
      
      const variantElements = document.querySelectorAll('.thumbnail-swatch');
      variantElements.forEach((ele) => {
        ele.addEventListener("click", () => {
          const inputID = ele.getAttribute("for");
          let colorValue = '';
          if (inputID) {
            colorValue = document.getElementById(inputID).value;
            console.log("This is the color value", colorValue);
          }
          
          console.log("This is the color value for slider", colorValue);
          // Find matching variant
          const matchedVariant = window.__productVariants.find(variant =>
            variant.options.includes(colorValue)
          );

          if (matchedVariant) {
            console.log("Here are matched color", matchedVariant.options);
            updateVariantImages(matchedVariant.id);
          }
        });
      });
      // document
      //   .querySelectorAll('[js-product-gallery-slider]')
      //   .forEach(element => {
      //     new Flickity(element, {
      //       prevNextButtons: false,
      //       adaptiveHeight: false,
      //       wrapAround: false,
      //       pageDots: false,
      //       contain: true,
      //       imagesLoaded: true,
      //       cellAlign: 'center',
      //       on: {
      //         ready: function() {
      //           this.select(1);
      //         }
      //       }
      //     })
      //   })
    }
    return {
      init: initialize
    }
  })();

  
	let popupInitApp = (() => {
		let initialize = () => {
			var overlay = document.getElementById('pdp-group-buy-popup-overlay');
			var closeBtn = document.querySelector('#pdp-group-buy-popup-overlay .gbpo-close');

			if (overlay) {
				var open = () => {
					overlay.classList.add('is-open');
					overlay.setAttribute('aria-hidden', 'false');
				}

				var close = () => {
					// console.log('close event')
					overlay.classList.remove('is-open')
					overlay.setAttribute('aria-hidden', 'true')
				}

				// Open on button click
				document.querySelectorAll('.gbpo-popup-button').forEach(element => {
					element.addEventListener('click', e => {
						e.preventDefault();
						open();
					})
				})

				// Close on close button click
				if (closeBtn) {
					closeBtn.addEventListener('click', close);
				}

				// Close on overlay background click
				overlay.addEventListener('click', e => {
					// console.log('close event', overlay, e.target);

					// if (e.target === overlay) close();
					if (e.target.classList.contains('mask') && e.target.classList.contains('close')) close();
				})

				// Close on Escape key
				document.addEventListener('keydown', e => {
					if (e.key === 'Escape') close();
				})
			}
		}
		return {
			init: initialize
		}
	})();
	
	let popupTreateApp = (() => {
		let initialize = () => {
			const minusBtn   = document.querySelector('.gbpo-quantity-selector-btn-minus');
			const plusBtn    = document.querySelector('.gbpo-quantity-selector-btn-plus');
			const valueEl    = document.querySelector('.gbpo-quantity-selector-value');
			const slider     = document.querySelector('.gbpo-quantity-selector-slider');
			const dots   = document.querySelectorAll('.gbpo-quantity-slider-dot');
			const discountTextEle = document.querySelector(".gbpo-quantity-selector-note");
			const discountedPriceEle = document.querySelector(".gbpo-quantity-selector-discount-price");
			// limited quantity offer
			const limitedQuantityOfferEle = document.querySelector(".gbpo-limited-quantity-offer");
			const limitedQuantityEle = document.querySelector(".gbpo-limited-quantity");
			const limitedQuantityResultPriceEle = document.querySelector(".gbpo-limited-quantity-result-price");

			// const MIN = parseInt(slider.min) || 10;
			const MIN = 1;
			// const MAX = parseInt(slider.max) || 500;
			const MAX = 500;
			const dotValues = [1];
			let segments = dots.length; // number of the space between quantity base value(10, 20, 50, 100, 150...)
			let unitPerSegment = 100;
			let sliderMax = unitPerSegment * segments;

			dots.forEach((dot) => {
				if (dot.dataset.value) {
					dotValues.push(Number(dot.dataset.value));
				}
			})

			const inputEle = document.getElementById("gbpo-input");
			const totalPriceEle = document.querySelector('.gppo-total-price');
			const totalPriceValueEle = document.querySelector('.gppo-total-price-value-container');
			const QuantitySelectorEle = document.querySelector('.pi-quantity-selector-text');
			const quantityItems = document.querySelectorAll('.gbpo-quantity');
			const addToCartButtonEle = document.querySelector('.gbpo-button');
			const subtotalPriceLabel = document.querySelector('.pi-subtotal-value');
			const unitPriceLabel = document.querySelector('.pi-unit-price-value');
			const variantPickerEle = document.querySelector('variant-picker');
			const addToCartButtonEle1 = document.querySelector('.pi-cta-button');
			let selectedQuantity = 10;
			let leftQuantity = 0; // left quantity to reach new price
			let enablePriceToReach = 0; // enable price to reach

			if (!quantityItems) return;
			quantityItems.forEach(ele => {
				ele.addEventListener("click", () => {
					quantityItems.forEach((element => {
						element.classList.remove("active");
					}));
					ele.classList.add("active");

					selectedQuantity = ele.querySelector('.gbpo-quantity-label')?.innerText;
					if (selectedQuantity) {
						selectedQuantity = selectedQuantity.replace(" Tassen", '');
						updateUI(selectedQuantity); 
					}

					let selectedPrice = ele.querySelector('.gbpo-quantity-price')?.getAttribute('data-price');
					if (selectedPrice) {
						selectedPrice = selectedPrice.replace("€", "");
					}

					let totalPrice = 0;
					if (selectedQuantity && selectedPrice) {
						totalPrice = (Number(selectedQuantity) * Number(selectedPrice)).toFixed(2);
					}

					// let currency_unit = window.formatMoney(totalPrice);
					if (totalPriceValueEle && subtotalPriceLabel && unitPriceLabel) {
						totalPriceValueEle.innerHTML = `${totalPrice}€`;

						console.log("These are the total price and the selected price......", totalPrice, selectedPrice);
						if (Number(selectedQuantity) > 1) {
							subtotalPriceLabel.innerHTML = `${totalPrice}€`;
						} else {
							subtotalPriceLabel.innerHTML = `ab ${totalPrice}€`;
						}
						unitPriceLabel.innerHTML = `ab ${selectedPrice}€ p.S`;
					}

					if (!inputEle) return;
					inputEle.value = selectedQuantity;
					totalPriceEle.classList.add("active");

					if (!QuantitySelectorEle) return;
					QuantitySelectorEle.innerHTML = selectedQuantity;

					addToCartButtonEle.classList.add("active");
				});
			})

			if (inputEle && totalPriceValueEle) {
				inputEle.addEventListener("change", (e) => {
					const priceElements = document.querySelectorAll(".gbpo-quantity");
					selectedQuantity = inputEle.value;
					if (Number(selectedQuantity) == 0) {
						totalPriceEle.classList.remove("active");
						addToCartButtonEle.classList.remove("active");
						discountTextEle.classList.remove("active");
						limitedQuantityOfferEle.classList.remove("active");

						return;
					}

					let compareAtPriceUnit = 0;
					let compareAtPrice = 0;
					let discountedPrice = 0;
					let minQuantity = 0;
					let selectedPrice = 0;

					console.log("This is the selected quantity", selectedQuantity);
					for (let i = 0; i < priceElements.length; i ++) {
						let quantity = priceElements[i].querySelector('.gbpo-quantity-label')?.textContent?.trim();
						console.log("This is the quantity label", priceElements[i].querySelector('.gbpo-quantity-label').innerHMTL);
						let priceEle = priceElements[i].querySelector('.gbpo-quantity-price');
						if (!priceEle) continue;

						let price = priceEle.getAttribute("data-price");
						if (quantity && price) {
							quantity = quantity.replace(" Tassen", '');
							console.log("Here is the quantity.....0", quantity, parseInt(quantity), Number(quantity));
							price = price.replace("€", "");
						}
						console.log("Here is the quantity.....1", quantity, parseInt(quantity), Number(quantity));

						if (i == 0) {
							selectedPrice = parseFloat(price);
							minQuantity = Number(quantity);

							compareAtPriceUnit = parseFloat(price);
						}
						if (Number(selectedQuantity) >= minQuantity && Number(selectedQuantity) >= Number(quantity)) {
							console.log("This is the selectedQuantity and quantity", parseInt(selectedQuantity), parseInt(quantity), Number(quantity));
							selectedPrice = parseFloat(price);
							minQuantity = Number(quantity);

							// clear the active class of all quantity selector(button)
							priceElements.forEach((element => {
								element.classList.remove("active");
							}));
							priceElements[i].classList.add("active");

							if (i == priceElements.length - 1 && Number(selectedQuantity) == Number(quantity)) {
								leftQuantity = 0; // left quantity to reach new price
								enablePriceToReach = parseFloat(price); // enable price to reach
							}
						} else if (Number(selectedQuantity) >= minQuantity && Number(selectedQuantity) < Number(quantity)) {
							// console.log("This is the selected quantity and current quantity", selectedQuantity, quantity);
							leftQuantity = Number(quantity) - Number(selectedQuantity); // left quantity to reach new price
							enablePriceToReach = parseFloat(price); // enable price to reach

							break;
						} else if (Number(selectedQuantity) < minQuantity ) {//deal extra case like the quantity is smaller than first value(10)
							let nextQuantity = priceElements[1].querySelector('.gbpo-quantity-label')?.innerText;
							let nextPriceEle = priceElements[1].querySelector('.gbpo-quantity-price');
							if (!nextPriceEle) continue;

							let nextPrice = nextPriceEle.getAttribute("data-price");
							if (nextQuantity && nextPrice) {
								nextQuantity = nextQuantity.replace(" Tassen", '');
								nextPrice = nextPrice.replace("€", "");
							}

							leftQuantity = Number(nextQuantity) - Number(selectedQuantity); // left nextQuantity to reach new nextPrice
							enablePriceToReach = Number(nextPrice); // enable nextPrice to reach
							// console.log("This is the selected quantity and current quantity", selectedQuantity, nextQuantity);

							break;
						}
					};

					let totalPrice = 0;
					totalPriceEle.classList.add("active");
					totalPrice = (Number(selectedQuantity) * Number(selectedPrice)).toFixed(2);

					compareAtPrice = (Number(selectedQuantity) * Number(compareAtPriceUnit)).toFixed(2);
					discountedPrice = (compareAtPrice - totalPrice).toFixed(2);
					if (discountedPriceEle) {
						discountedPriceEle.textContent = `${discountedPrice}€`;
						limitedQuantityEle.textContent = leftQuantity;
						limitedQuantityResultPriceEle.textContent = `${enablePriceToReach}€`;
					}

					// let currency_unit = window.formatMoney(totalPrice);
					if (totalPriceValueEle && subtotalPriceLabel && unitPriceLabel) {
						console.log("These are the total price and the selected price......", totalPrice, selectedPrice);
						totalPriceValueEle.innerHTML = `${totalPrice}€`;

            if (Number(selectedQuantity) > 1) {
              subtotalPriceLabel.innerHTML = `${totalPrice}€`;
            } else {
              subtotalPriceLabel.innerHTML = `ab ${totalPrice}€`;
            }
						unitPriceLabel.innerHTML = `ab ${selectedPrice}€ p.S`;
					}

					if (!QuantitySelectorEle) return;
					QuantitySelectorEle.innerHTML = selectedQuantity;
					addToCartButtonEle.classList.add("active");
					discountTextEle.classList.add("active");
					limitedQuantityOfferEle.classList.add("active");
				});
			}

			let quantityToSlider = (qty) => {
				for (let i = 0; i < segments; i ++) {
					if (qty >= dotValues[i] && qty <= dotValues[i + 1]) {
						const fraction = (qty - dotValues[i]) / (dotValues[i + 1] - dotValues[i]);
			      return Math.round((i + fraction) * unitPerSegment);
					}
				}
				if (qty <= dotValues[0]) return 0;
				return sliderMax;
			}
			let sliderToQuantity = (sliderVal) => {
				const pos      = (sliderVal / sliderMax) * segments;
				const segIndex = Math.min(Math.floor(pos), segments - 1);
				const fraction = pos - segIndex;
				const from     = dotValues[segIndex];
				const to       = dotValues[segIndex + 1];
				return Math.round(from + (to - from) * fraction);
			}

			let positionDots = () => {
				dots.forEach((dot, i) => {
					const pct = (i / segments) * 100;
					dot.style.left = pct + '%';
				})
			}
			let updateSliderFill = (sliderVal) => {
				sliderVal = Math.max(0, Math.min(sliderMax, sliderVal));
				const qty = sliderToQuantity(sliderVal);
				const pct = (sliderVal / sliderMax) * 100;
				// const pct = ((quantity - MIN) / (MAX - MIN)) * 100;
    		slider.style.background = `linear-gradient(to right, #173586 ${pct}%, #FFF ${pct}%)`;

				const activeSeg = sliderVal / unitPerSegment;
				dots.forEach((dot, i) => {
					// dot.classList.toggle('is-passed', dotValues[i] <= quantity);
					dot.classList.toggle('is-passed', i <= activeSeg);
				});
			}
			let updateUI = (qty) => {
				qty = Math.max(MIN, Math.min(MAX, qty));

				valueEl.textContent = qty;
				slider.value = quantityToSlider(qty);
				inputEle.value = qty;

				updateSliderFill(quantityToSlider(qty));
				// trigger input change event
				const event = new Event('change', { bubbles: true });
				inputEle.dispatchEvent(event);
			}
			// Minus / Plus buttons
			minusBtn.addEventListener('click', (e) => {
				e.preventDefault();
				const newQty = Math.max(0, parseInt(valueEl.textContent) - 1);
				updateUI(newQty);
			});

			plusBtn.addEventListener('click', (e) => {
				e.preventDefault();
				const newQty = Math.max(0, parseInt(valueEl.textContent) + 1);
				updateUI(newQty);
			});

			// Slider
			slider.addEventListener('input', () => {
				updateUI( sliderToQuantity( parseInt(slider.value) ) );
				console.log("This is the slider value", slider.value);
			});

			let updateVariantUrl = () => {
				let connectLinkFunc = () => {
					let targetLinkStr = "https://tassenexpress.store/apps/zakeke?pid=8172823511290&handle=tassen-mit-logo-bedrucken-keramik&quantity=250&locale=de";
					const targetURL = new URL(targetLinkStr);
	
					let variantId = '';
					if (variantPickerEle && variantPickerEle.getAttribute("form")) {
						const formEle = document.forms[variantPickerEle.getAttribute("form")];
						if (formEle && formEle.id) {
							variantId = formEle.id.value ? formEle.id.value : '';
						}
					}
					targetURL.searchParams.set('id', variantId);
					// targetURL.searchParams.set('variant', variantId);
					targetURL.searchParams.set('quantity', selectedQuantity);
					// addToCartButtonEle.classList.add("active");

          console.log(targetURL.toString());
					window.location.href = targetURL.toString();
				}

				if (addToCartButtonEle) {
					addToCartButtonEle.addEventListener("click", (e) => {
						connectLinkFunc();
					});
				}

				if (addToCartButtonEle1) {
					addToCartButtonEle1.addEventListener("click", (e) => {
						connectLinkFunc();
					});
				}
			}

			positionDots();
			updateVariantUrl();
			
      // initiate the quantity and the price
      // const popupOverlay = document.querySelector(".pdp-group-buy-popup-overlay");

      // if (popupOverlay) {
      //   popupOverlay.classList.add("is-open");
      //   popupOverlay.classList.add("not-visible");

      //   setTimeout(() => {
      //     const slider = document.querySelector(".gbpo-quantity-selector-slider");
 
      //     if (slider) {
      //       slider.value = 100;
      //       slider.dispatchEvent(new Event("input", { bubbles: true }));
      //       slider.dispatchEvent(new Event("change", { bubbles: true }));
      //     }

      //     setTimeout(() => {
      //       popupOverlay.classList.remove("is-open");
      //       popupOverlay.classList.remove("not-visible");
      //     }, 100);
      //   }, 200);
      // }
		}
		return {
			init: initialize
		}
	})();

  let App = (() => {
    let initialize = () => {
			BDTabContainerApp.init();
			FAQApp.init();
      variantPickerApp.init();
      pdpAsLandingSliderApp.init();
      
    }
    return {
      init: initialize
    }
  })();
  
  document.addEventListener('DOMContentLoaded', () => {
    App.init();
  });
})();

/* TX 21.10.: Klaviyo-Popup YAr3PD weicht dem Consentmo-Cookie-Hinweis aus, am Handy und am Desktop (ersetzt die
   CSS-Zwischenlösung snap-0145; Regeln in custom.css unter body.tx-kl-ausweichen). Greift nur, solange das Popup offen
   und der Hinweis sichtbar ist (.cc-window, auch im Shadow DOM von <csm-cookie-consent>; Handy unten über die Breite,
   Desktop unten rechts) und in Klaviyos mittiger Lage Inhalt des Formulars verdecken würde. Verdeckt heißt: ein Element
   ohne Kinder (> 2 px) reicht waagerecht in den Hinweis, und seine Unterkante liegt unter der Oberkante des Hinweises
   (z. B. der Datenschutz-Link bei 1280×800). Dann rückt das Popup so weit hoch, dass die unterste solche Zeile
   („Abmeldung jederzeit möglich · Datenschutz“) 8 px über dem Hinweis steht, höchstens aber, bis der Popup-Inhalt 12 px
   unter dem oberen Rand beginnt (wie snap-0145, nie höher; außerhalb von dessen Media Query ≤ 779 × ≤ 1000 px
   höchstens bis zu Klaviyos eigener Lage, wenn die höher liegt). Reicht das nicht, bleibt der untere Teil zunächst verdeckt, und
   darunter gibt es genau so viel Scrollraum, dass sich das Formular bis zu dieser Zeile 8 px über den Hinweis wischen
   lässt. Sonst (Hinweis weg oder nie da, nichts verdeckt, z. B. 1920×1080) Klasse weg → Klaviyo-Standard (mittig).
   Klaviyos Einblend-Verschiebung des Formulars (klaviyo-fadeinup) wird herausgerechnet, Änderungen ≤ 1 px bleiben
   liegen; die Lage steht also schon beim Einblenden fest. Fremdes Markup oder CSS greift nicht (z. B. kein :has()) →
   Klasse weg, bis das Popup wieder zu ist; ebenso bei mehr als 10 eigenen Änderungen in 2 s ohne Größenwechsel des
   Fensters (Pendeln). Fehler → Klasse weg und Ruhe; neuer Versuch bei der nächsten Änderung am <body> oder am Rahmen
   (das Entfernen der Klasse löst selbst genau einen aus). Kein Eingriff in Consent oder Klaviyo; der Hinweis bleibt
   unangetastet.
   Wach nur bei Bedarf: Jede Änderung direkt am <body> (Klasse oder Kinder, ohne Unterbaum; Klaviyo setzt beim Öffnen
   eine Klasse, auch bei openForm aus dem Chat, das nicht immer ein Ereignis liefert) oder am Stil des einmal gesehenen
   Klaviyo-Rahmens, das Ereignis „klaviyoForms“ und pageshow starten einen Takt (400 ms), der 3 s lang nach dem
   offenen Popup sucht und läuft, solange es offen ist; danach ruht alles bis zur nächsten Änderung.
   Layout wird nur bei offenem Popup gemessen. */
(() => {
  const KL = 'tx-kl-ausweichen', ID = 'YAr3PD', OBEN = 12, LUFT = 8, WACH = 3000, b = document.body;
  if (!b || !window.MutationObserver) return;
  // Grenze nach oben: wo snap-0145 griff (≤ 779 × ≤ 1000 px), dessen 12 px; sonst Klaviyos eigene Lage (höchstens 12 px)
  const alt = window.matchMedia && window.matchMedia('(max-width: 779px) and (max-height: 1000px)');
  const ATTR = { attributes: true, attributeFilter: ['class', 'style', 'hidden'] };
  const BAUM = Object.assign({ childList: true, subtree: true }, ATTR);
  let takt = 0, bis = 0, plan = 0, gen = 0, sperre = null, altT = NaN, altN = NaN, t0 = 0, hoehe = 0, breite = 0, mo = null, ro = null;
  let dabei = null, schrieb = [], rahmen = null;
  const viel = () => { // zählt eigene Änderungen am <body>: mehr als 10 in 2 s = Pendeln (Größenwechsel setzt zurück)
    const j = Date.now();
    schrieb = schrieb.filter((z) => j - z < 2000); schrieb.push(j);
    return schrieb.length > 10;
  };
  const aus = () => {
    altT = altN = NaN;
    if (!b.classList.contains(KL)) return;
    viel(); b.classList.remove(KL);
    b.style.removeProperty('--tx-kl-oben'); b.style.removeProperty('--tx-kl-unten');
  };
  const ruhen = () => { // Klasse weg, Takt und Beobachter aus; nur „wach“ (unten) bleibt
    aus(); clearInterval(takt); takt = 0; sperre = null;
    if (mo) mo.disconnect();
    if (ro) ro.disconnect();
    mo = ro = dabei = null;
  };
  const folgen = (el, opt) => {
    if (dabei.has(el)) return;
    dabei.add(el); if (opt) mo.observe(el, opt); if (ro && el.nodeType === 1) ro.observe(el);
  };
  const sichtbar = (e, deckend) => {
    if (e.checkVisibility) { // beide Optionsnamen: Chrome 105–120 und Firefox 106–121 kennen nur die alten
      const k = deckend;
      return e.checkVisibility({ opacityProperty: k, visibilityProperty: k, checkOpacity: k, checkVisibilityCSS: k });
    }
    if (!e.getClientRects().length) return false; // Safari < 17.4: display: none, auch an einem Vorfahren
    const s = getComputedStyle(e);
    return !deckend || (s.visibility !== 'hidden' && +s.opacity > 0);
  };
  // Rechteck des obersten sichtbaren Cookie-Hinweises, der unten steht, oder null
  const hinweis = () => {
    let h = null;
    const nimm = (e) => {
      if (!sichtbar(e, true)) return;
      folgen(e);
      const r = e.getBoundingClientRect();
      if (r.height >= 20 && r.width >= 50 && r.top < innerHeight && r.bottom >= innerHeight - 80 && (!h || r.top < h.top)) h = r;
    };
    document.querySelectorAll('.cc-window').forEach(nimm);
    document.querySelectorAll('csm-cookie-consent, .csm-cmp-root').forEach((w) => {
      const sr = w.shadowRoot;
      if (!sr) return;
      w.addEventListener('toggle', wecken); // dieselbe Funktion hängt nur einmal
      folgen(sr, BAUM); folgen(w, ATTR);
      sr.querySelectorAll('.cc-window, [aria-label="Cookie bar"]').forEach(nimm);
    });
    return h;
  };
  // Verschiebung des Formulars f gegenüber seiner Ruhelage (Einblend-Animation klaviyo-fadeinup auf w oder einem
  // Vorfahren von f). Ruhelage = Layout (offsetTop) plus Klaviyos Skalierung von w (scale um transform-origin).
  const schub = (w, f, o) => {
    const s = getComputedStyle(w), m = /^matrix(3d)?\(([^)]*)\)$/.exec(s.transform || '');
    const k = m ? +m[2].split(',')[m[1] ? 5 : 3] || 1 : 1, oy = parseFloat(String(s.transformOrigin).split(' ')[1]) || 0;
    let fy = 0, e = f;
    for (; e && e !== w; e = e.offsetParent) fy += e.offsetTop;
    return e === w ? f.getBoundingClientRect().top - (o + oy + k * (fy - oy)) : 0;
  };
  const pruefen = () => {
    if (!mo) return; // ruht
    const f = document.querySelector('[data-testid="klaviyo-form-' + ID + '"]'), d = f && f.closest('[role="dialog"]');
    if (d && d !== rahmen) { rahmen = d; wach.observe(d, ATTR); } // Klaviyo blendet den Rahmen per Stil ein und aus
    if (!d || !sichtbar(d, false)) { // zu: Klasse weg (Pendel-Zähler neu), nach 3 s ruht alles
      sperre = null; aus(); schrieb = [];
      if (Date.now() > bis) ruhen();
      return;
    }
    bis = Date.now() + WACH; folgen(d, BAUM); folgen(f);
    const w = d.firstElementChild, h = !sperre && hinweis();
    if (!h || !w || d.childElementCount !== 1 || w.offsetParent !== d || f.offsetHeight < 50) return aus();
    // Lagen relativ zur Layout-Oberkante des Inhalts w (Klaviyo skaliert w am Handy per transform: scale um die Mitte;
    // die Skalierung bleibt in den Rechtecken, die Einblend-Verschiebung wird abgezogen)
    const dr = d.getBoundingClientRect(), H = d.clientHeight, LH = w.offsetHeight, mitte = (H - LH) / 2;
    const o0 = dr.top + d.clientTop - d.scrollTop + w.offsetTop, o = o0 + schub(w, f, o0), rand = h.top - dr.top - d.clientTop;
    let ende = -Infinity; // Unterkante des untersten Inhalts (Element ohne Kinder, > 2 px), der waagerecht im Hinweis liegt
    f.querySelectorAll('*').forEach((e) => {
      if (e.childElementCount) return;
      const r = e.getBoundingClientRect();
      if (r.width > 2 && r.height > 2 && r.left < h.right && r.right > h.left && r.bottom - o > ende) ende = r.bottom - o;
    });
    if (mitte + ende <= rand) return aus(); // mittig verdeckt der Hinweis nichts: Klaviyo-Standard
    // Tastatur in Browsern, die dafür das Fenster verkleinern (gleiche Breite, ≥ 200 px niedriger, Feld im Popup hat den
    // Fokus): Lage halten, nur den Scrollraum für die neue Höhe rechnen. Adressleiste (< 200 px) und Drehen rechnen neu.
    const a = document.activeElement, halten = !!a && f.contains(a) && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) &&
      b.classList.contains(KL) && innerWidth === breite && H < hoehe - 200;
    const grenze = alt && !alt.matches ? Math.max(0, Math.min(OBEN, mitte)) : OBEN;
    const t = halten ? t0 : Math.floor(Math.max(grenze, rand - LUFT - ende));
    const noetig = t + ende - (rand - LUFT); // > 0: so weit wischen, bis die unterste Zeile 8 px über dem Hinweis steht
    const nach = noetig > 0 ? Math.max(0, Math.ceil(noetig + H - t - LH) + 1) : 0;
    if (!halten) { t0 = t; hoehe = H; breite = innerWidth; }
    if (!(Math.abs(t - altT) <= 1 && Math.abs(nach - altN) <= 1)) { // ≤ 1 px (Rundung) bleibt liegen
      if (viel()) { sperre = d; return aus(); } // pendelt: bis das Popup zu ist, Klaviyo-Standard
      b.style.setProperty('--tx-kl-oben', t + 'px'); b.style.setProperty('--tx-kl-unten', nach + 'px'); altT = t; altN = nach;
    }
    if (!b.classList.contains(KL)) b.classList.add(KL); // add() schriebe das Attribut sonst bei jedem Takt neu
    // CSS greift nicht (z. B. kein :has()): bis das Popup zu ist, Klaviyo-Standard
    if (getComputedStyle(d).flexDirection !== 'column' || Math.abs(parseFloat(getComputedStyle(w).marginTop) - altT) > 1) {
      sperre = d; aus();
    }
  };
  const planen = () => { // gebündelt vor dem nächsten Bild; kommt keins (Hintergrund-Tab), nach 100 ms
    if (plan) return;
    plan = 1;
    const g = ++gen; // der jeweils andere Weg (Bild oder 100 ms) dieses Laufs verfällt, auch für spätere Läufe
    const jetzt = () => {
      if (!plan || g !== gen) return;
      plan = 0;
      try { pruefen(); } catch (e) { ruhen(); }
    };
    if (window.requestAnimationFrame) requestAnimationFrame(jetzt);
    setTimeout(jetzt, 100);
  };
  const wecken = () => {
    bis = Date.now() + WACH;
    if (!mo) {
      dabei = new WeakSet(); mo = new MutationObserver(planen); ro = window.ResizeObserver ? new ResizeObserver(planen) : null;
    }
    if (!takt) takt = setInterval(planen, 400);
    planen();
  };
  const wach = new MutationObserver(wecken); // bleibt immer: <body> (Klasse, Kinder) und der zuletzt gesehene Rahmen
  wach.observe(b, { childList: true, attributes: true, attributeFilter: ['class'] });
  window.addEventListener('klaviyoForms', (e) => { const i = e.detail && e.detail.formId; if (!i || i === ID) wecken(); });
  const neu = () => { schrieb = []; if (takt) planen(); }; // Größenwechsel: neue Werte sind kein Pendeln
  window.addEventListener('resize', neu);
  window.addEventListener('orientationchange', neu);
  window.addEventListener('pageshow', wecken);
  wecken();
})();
